// extracted by mini-css-extract-plugin
export default {"img":"ModalOrderDetails_img__MOK2-","title":"ModalOrderDetails_title__Krq0Y"};